<template>
  <div>
    <h1>Managers List</h1>
    <div class="form-group">
      <b-button v-b-modal.managers-modal variant="outline-success"><i class="fa fa-user-plus"></i> Add Manager</b-button>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table" id="managers">
            <thead>
              <th>Name</th>
              <th>Email</th>
              <th>Remove</th>
            </thead>
            <tbody>
              <ManagerItemRemove v-for="manager in managers" v-bind:manager="manager" v-bind:key="manager.id" @removeManager="removeManager"></ManagerItemRemove>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal id="managers-modal" title="Select Manager">
      <div class="table-responsive">
        <table class="table" id="managers">
          <thead>
            <th>Name</th>
            <th>Email</th>
            <th>Add</th>
          </thead>
          <tbody>
            <ManagerItemAdd v-for="manager in nonmanagers" v-bind:manager="manager" v-bind:key="manager.id" @addManager="addManager"></ManagerItemAdd>
          </tbody>
        </table>
      </div>
    </b-modal>

  </div>
</template>

<script>
import ManagerItemAdd from '@/components/ManagerItemAdd'
import ManagerItemRemove from '@/components/ManagerItemRemove'

export default {
  name: 'Managers',

  components: {
    'ManagerItemAdd': ManagerItemAdd,
    'ManagerItemRemove': ManagerItemRemove
  },

  data () {
    return {
      managers: null,
      nonmanagers: null
    }
  },

  mounted () {
    this.loadManagers()
    this.loadNonManagers()
  },

  methods: {
    loadManagers () {
      this.$http
        .get(process.env.VUE_APP_URL + '/managers')
        .then(response => (this.managers = response.data))
    },
    loadNonManagers () {
      this.$http
        .get(process.env.VUE_APP_URL + '/nonmanagers')
        .then(response => (this.nonmanagers = response.data))
    },
    reloadAll () {
      this.loadNonManagers()
      this.loadManagers()
    },
    addManager (manager) {
      this.$http
        .post(process.env.VUE_APP_URL + '/managers', { id: manager.id })
        .then(response => {
          this.$bvModal.hide('managers-modal')
          this.reloadAll()
          response
        })
    },
    removeManager (manager) {
      this.$http
        .delete(process.env.VUE_APP_URL + '/managers/' + manager.id)
        .then(response => {
          this.reloadAll()
          response
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
